import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import WelcomeHeader from '../components/layout/WelcomeHeader';
import styles from './InfoPage.module.css';

function About({ loggedIn, username }) {
  const { t } = useTranslation();
  return (
    <>
      <WelcomeHeader loggedIn={loggedIn} username={username} />
      <div className={styles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.pageTitle}>{t('about.title')}</h1>
          <div className={styles.content}>
            <p>{t('about.p1')}</p>
            <p>{t('about.p2')}</p>

            <h2>{t('about.featuresTitle')}</h2>
            <ul>
              <li>{t('about.f1')}</li>
              <li>{t('about.f2')}</li>
              <li>{t('about.f3')}</li>
              <li>{t('about.f4')}</li>
              <li>{t('about.f5')}</li>
              <li>{t('about.f6')}</li>
              <li>{t('about.f7')}</li>
              <li>{t('about.f8')}</li>
            </ul>

            <h2>{t('about.openSourceTitle')}</h2>
            <p>
              <Trans
                i18nKey="about.openSourceText"
                // eslint-disable-next-line jsx-a11y/anchor-has-content -- Inhalt kommt zur Laufzeit aus der Übersetzung
                components={[<a key="0" href="https://github.com/KilianJATO/MangaOrganisation" target="_blank" rel="noopener noreferrer" />]}
              />
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
